import React, { ReactNode } from 'react';
import { PartialSearchingProps, SearchingProps } from 'modules/Shared/type';
import { PageProps } from 'modules/Layout/type';
import { managePageAction, ManagePageAction } from 'modules/Layout/action';
import { Dispatch } from 'redux';
import { breadcrumbRoutePlants } from 'modules/Plants/breadcrumbs';
import { connect } from 'react-redux';
import Listing from 'modules/Layout/component/Listing';
import PlantTable from 'modules/Plants/container/Table';
import PlantFilter from 'modules/Plants/container/Filter';
import PlantPagination from 'modules/Plants/container/Pagination';
import PlantPerPage from 'modules/Plants/container/PerPage';
import Plant from 'modules/Plants/model/Plant';
import { createSearchingProps } from 'modules/Shared/helper/params';
import {
  setPlantListParamsAction,
  SetPlantListParamsAction
} from 'modules/Plants/action/list';
import { RootState } from 'app/reducer';

export interface StateProps {
  fetching: boolean;
  type: string;
}

export interface DispatchProps {
  managePage: (payload: PageProps) => ManagePageAction;
  setParams: (payload: PartialSearchingProps) => SetPlantListParamsAction;
}

export type Props = StateProps & DispatchProps;

export const mapDispatch = (dispatch: Dispatch): DispatchProps => ({
  managePage: (payload: PageProps) => dispatch(managePageAction(payload)),
  setParams: (payload: PartialSearchingProps) =>
    dispatch(setPlantListParamsAction(payload))
});

export const mapState = (state: RootState): StateProps => {
  const { fetching } = state.plant.list;
  const { type } = state.layout.page;

  return { fetching, type };
};

export class PlantsListView extends React.Component<Props> {
  protected searchProps: SearchingProps;

  constructor(props: Props) {
    super(props);

    this.searchProps = createSearchingProps(
      window.location.hash,
      Plant.getFilterableAttributes(),
      Plant.getSortableAttributes()
    );
  }

  componentDidMount(): void {
    const { managePage, setParams } = this.props;

    managePage({
      title: 'Plants - list',
      breadcrumb: breadcrumbRoutePlants()
    });

    setParams(this.searchProps);
  }

  render(): ReactNode {
    const { fetching, type } = this.props;
    const { filter } = this.searchProps;

    if (type) return null;
    return (
      <div className="row Plants-view">
        <div className="col-12">
          <Listing
            table={<PlantTable />}
            filter={<PlantFilter values={filter} />}
            pagination={<PlantPagination />}
            perPage={<PlantPerPage />}
            addBtn={{ text: 'Add plant', url: '/plant/add' }}
            loading={fetching}
          />
        </div>
      </div>
    );
  }
}

export default connect<StateProps, DispatchProps>(
  mapState,
  mapDispatch
)(PlantsListView);
